import { React, useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { IoIosSend } from "react-icons/io";
import { endPoints } from "../../Constant/Environment";
import swal from 'sweetalert';
import Loader from "../Loader/index";
import { addItemApi } from "../../Utility/Api";
import { contactSchema } from "../Schemas";
import { useFormik } from "formik";

const initialValues = {
  name: '',
  email: '',
  mobile: '',
  subject: '',
  query: '',
};


function ContactForm() {

  const [isLoading, setIsLoadinig] = useState(false);
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: contactSchema,
      onSubmit: (values, action) => {
        submitApi(values);
        action.resetForm();
      },
    });

  async function submitApi(formData) {

    try {
      const url = `${endPoints.api.QUERYSUBMIT}`;
      setIsLoadinig(true);

      const response = await addItemApi(url, formData);
      console.log(response);
      if (response.status === 200) {

        setIsLoadinig(false);
        swal('Success!', response.message, 'success');

      } else {
        setIsLoadinig(false);
      }
    } catch (error) {
      setIsLoadinig(false);
    }

  }

  return (
    <>
      <Form

        onSubmit={handleSubmit}
        className="contact-form Reative"
      >
        {isLoading && <Loader spinner={true} visible={isLoading} className="LoaderForm" />}

        <Row className="mt-5">
          <Form.Group as={Col} md="6" controlId="validationCustom01">
            <Form.Label>Your Name</Form.Label>
            <Form.Control type="text" name="name" value={values.name}
              onChange={handleChange} onBlur={handleBlur} />

            {errors.name && touched.name ? (
              <small className="text-danger">{errors.name}</small>
            ) : null}
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="validationCustom02">
            <Form.Label>E-Mail ID</Form.Label>
            <Form.Control type="email" name="email" value={values.email}
              onChange={handleChange} onBlur={handleBlur} />
            {errors.email && touched.email ? (
              <small className="text-danger">{errors.email}</small>
            ) : null}

          </Form.Group>
          <Form.Group as={Col} md="6" controlId="validationCustom03">
            <Form.Label>Phone No.</Form.Label>
            <Form.Control type="number" name="mobile" value={values.mobile}
              onChange={handleChange} onBlur={handleBlur} />
            {errors.mobile && touched.mobile ? (
              <small className="text-danger">{errors.mobile}</small>
            ) : null}

          </Form.Group>
          <Form.Group as={Col} md="6" controlId="validationCustom04">
            <Form.Label>Subject</Form.Label>
            <Form.Control type="text" name="subject" value={values.subject}
              onChange={handleChange} onBlur={handleBlur} />
            {errors.subject && touched.subject ? (
              <small className="text-danger">{errors.subject}</small>
            ) : null}

          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} md="12" controlId="validationCustom05">
            <Form.Label>Your Query</Form.Label>
            <Form.Control
              as="textarea"
              style={{ height: "120px", marginBottom: "3rem" }}
              name="query"
              value={values.query}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.query && touched.query ? (
              <small className="text-danger">{errors.query}</small>
            ) : null}

          </Form.Group>
        </Row>
        <Button type="submit" className="send-btn">
          Send Message
          <IoIosSend />
        </Button>
      </Form>
    </>
  );
}

export default ContactForm;
